import React from 'react';

const UsersContext = React.createContext({
  roles: [],
});

export default UsersContext;
